// Module
var code = "<td name=verticalLayerIndex>{{ record.key | entityFormat }}</td> <td name=quantity>{{ getRemainingQuantity(record) }}</td> <td name=shipmentUnitProductQuantity>{{ getRemainingProductQuantity(record) }}</td> <td name=deliveryUnit>{{ record.value[0].deliveryUnitData.deliveryUnit | entityFormat }}</td> ";
// Exports
module.exports = code;